import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const sinKit = ['Domingos armando la clase', 'Explicar 3 veces lo mismo', 'Sin experimentos por falta de lab', 'Planificación desde cero', 'Corregir sin rúbrica', 'Buscar ejercicios en internet'];
const conKit = ['Ficha lista en 5 minutos', 'Analogía que se entiende a la primera', '15 labs con materiales caseros', 'Planificador anual editable', 'Rúbrica de corrección incluida', '96 ejercicios resueltos'];
export function Comparativa() {
  return <section className="px-4 py-10" aria-labelledby="comparativa-title" data-id="element-47" data-mp="136eec19fylcu">
      <h2 id="comparativa-title" className="text-center font-display text-xl font-extrabold text-white" data-id="element-48" data-mp="17yfnhebbbvyn">
        Sin el Kit <span className="text-teal-200/60" data-id="element-49" data-mp="1bzhmbu1bi603">vs</span>{' '}
        <span className="text-orange-400" data-id="element-50" data-mp="1h05eij1a8svw">Con el Kit</span>
      </h2>

      <div className="mt-5 grid grid-cols-2 gap-2" data-id="element-51" data-mp="1lygpix3bd9fp">
        <div className="rounded-xl border border-red-400/25 bg-[#1a0f10]/80 p-2.5" data-id="element-52" data-mp="1lyyseckhelwl">
          <p className="mb-2 text-center text-[11px] font-bold uppercase tracking-wide text-red-300" data-id="element-53" data-mp="l175q5c75wzn">
            Sin el Kit
          </p>
          <ul className="space-y-1.5" data-id="element-54" data-mp="g35qjvhw6htg">
            {sinKit.map(t => <li key={t} className="flex gap-1.5" data-id="element-55" data-mp="bzzlusafgyp3">
                <XIcon className="mt-[2px] h-3 w-3 flex-none text-red-400" aria-hidden="true" data-id="element-56" data-mp="70mp9ftr8d9b" />
                <span className="text-[11.5px] leading-tight text-red-50/85" data-id="element-57" data-mp="13q44alemnbno">
                  {t}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="rounded-xl border border-emerald-400/30 bg-[#0b2b2e]/85 p-2.5" data-id="element-58" data-mp="uxabdl69cdrc">
          <p className="mb-2 text-center text-[11px] font-bold uppercase tracking-wide text-emerald-300" data-id="element-59" data-mp="q00jlyvebq0c">
            Con el Kit
          </p>
          <ul className="space-y-1.5" data-id="element-60" data-mp="1ngpknqciuo8o">
            {conKit.map(t => <li key={t} className="flex gap-1.5" data-id="element-61" data-mp="1in4n1zeubwa0">
                <CheckIcon className="mt-[2px] h-3 w-3 flex-none text-emerald-400" aria-hidden="true" data-id="element-62" data-mp="21ketvnh4q17i" />
                <span className="text-[11.5px] leading-tight text-emerald-50/90" data-id="element-63" data-mp="26igbs52tjuhe">
                  {t}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}